export default __webpack_public_path__ + "64f01d44813d9e58fbc05ca7e51595c7.svg";